import * as React from 'react'

import { Theme } from '@mui/material/styles'

import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

import { useGetBillToOnMount } from '@user/store/entityLocations/hooks/useGetBillToOnMount'
import { TidalBillToSelectCardContents } from '../BillToSelect/BillToRadioCard/BillToRadioCardContents'

type Props = {
  billToId: string
  headerContent?: React.ReactNode
  maxWidth?: string
  width?: string
  onClearClick?: () => void
  viewOnly?: boolean
}

export function TidalBillToCardBasic(props: Props) {
  const { billToId, headerContent, onClearClick, viewOnly } = props
  const { billTo, loadingStatus } = useGetBillToOnMount(billToId)

  const showLoadingIndicator = loadingStatus === 'pending' || !billTo

  if (viewOnly) {
    return (
      <>
        {showLoadingIndicator ? (
          <Box display="flex" justifyContent="center" alignItems="center">
            <CircularProgress />
          </Box>
        ) : (
          <TidalBillToSelectCardContents
            isClearable
            onClearClick={onClearClick}
            headerContent={headerContent}
            location={billTo}
            viewOnly
          />
        )}
      </>
    )
  }

  return (
    <Paper
      elevation={2}
      sx={{
        marginBottom: (theme: Theme) => theme.spacing(1),
        paddingTop: (theme: Theme) => theme.spacing(2.125),
        paddingLeft: (theme: Theme) => theme.spacing(3),
        paddingRight: (theme: Theme) => theme.spacing(3),
        paddingBottom: (theme: Theme) => theme.spacing(1),
      }}
    >
      {showLoadingIndicator ? (
        <Box display="flex" justifyContent="center" alignItems="center">
          <CircularProgress />
        </Box>
      ) : (
        <TidalBillToSelectCardContents
          isClearable
          onClearClick={onClearClick}
          headerContent={headerContent}
          location={billTo}
        />
      )}
    </Paper>
  )
}
